export const withEmptyFallback = (arr, fallback) =>
	arr.length ? arr : [fallback];
